export default __webpack_public_path__ + "static/4-9eb3a556214683a9630f7382c16295a8.jpg";